import { createToastInterface, TYPE } from 'vue-toastification';
import { h } from 'vue';
import constants from '$$helpers/constants';
import ToastIcon from './ToastIcon.vue';
import toastMessage from './toastMessage.vue';

const toast = createToastInterface({
  ...constants.TOAST_CONFIG,
  closeButton: h(ToastIcon, { type: 'close' }),
  component: toastMessage,
  toastDefaults: {
    [TYPE.SUCCESS]: {
      icon: h(ToastIcon, { type: TYPE.SUCCESS }),
    },
    [TYPE.INFO]: {
      icon: h(ToastIcon, { type: TYPE.INFO }),
    },
    [TYPE.WARNING]: {
      icon: h(ToastIcon, { type: TYPE.WARNING }),
    },
    [TYPE.ERROR]: {
      icon: h(ToastIcon, { type: TYPE.ERROR }),
    },
  },
});

// please use only typed methods to create toasts, i.e. toast.success('Message'), toast.error('Message'), etc.
// default toast() method acts as info toast

[TYPE.SUCCESS, TYPE.INFO, TYPE.WARNING, TYPE.ERROR].forEach(type => {
  toast[type] = (content = '', options = {}) => {
    if (typeof content === 'string') {
      return toast({ component: toastMessage, props: { message: content } }, { ...options, type });
    }

    return toast(content, { ...options, type });
  };
});

export default toast;
